import type { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { SettingsTabRedirect } from "../settings-tab-redirect";
import { shippingSettingsRoutes as originalRoutes } from "./shipping";

export const shippingSettingsRoutes: PermissionedRouteObject[] =
  originalRoutes.map((route) => {
    if (route.path !== "fulfillment-cutoff") {
      return route;
    }
    const { lazy: _lazy, ...base } = route;
    return {
      ...base,
      element: (
        <SettingsTabRedirect
          from="/settings/fulfillment-cutoff"
          section="fulfillment-promise"
          to="/settings/order-management"
        />
      ),
    };
  });
